<template>
<div>
  <div class="card-body">
    <h5 class="card-title">{{ title }} <small class="text-muted" v-show="subTitle">{{ subTitle }}</small></h5>
    <p v-show="paging.itemsPerPage === orders.length">
      <router-link :to='{ name: "Production" }'>Več zadetkov</router-link><br>
    </p>
    <ul>
      <li v-for="wo in orders" class="mt-1">
        <router-link :to="{ name: 'ProductionOrder', params: { workOrderId: wo.id } }" class="me-1">{{ wo.orderNumber }}</router-link>
        <OrderBadge :workOrder="wo" />&nbsp;<strong>{{ wo.facilityName }}</strong>&nbsp;
        <br>
        <small class="text-muted">{{ wo.subject }}</small>
      </li>
    </ul>
    <p v-show="orders.length === 0">Ni nalogov.</p>
    <p v-show="paging.itemsPerPage === orders.length">
      <router-link :to='{ name: "Service" }'>Več zadetkov</router-link><br>
    </p>
  </div>
</div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { DATETIME_FOR_LOCAL_INPUT, EMPTY_GUID } from "../utils/constants"
import { useWorkOrders } from "../composition-api/useWorkOrders"

defineOptions({ name: "ProductionOrdersCard" })

const props = defineProps({
    statuses: {
      type: String,
      default: "Active,Accepted,InProgress",
    },
    ownerID: {
      type: String,
      default: EMPTY_GUID,
    },
    title: {
      type: String,
      default: "Proizvodni nalogi",
    },
    subTitle: {
      type: String,
      default: "Active,Accepted,InProgress",
    },
    itemsPerPage: {
      type: Number,
      default: 25,
    },
  })

const emit = defineEmits(["assigned"])

const { resetPaging, filters, orders, paging } = useWorkOrders("Production")

onMounted(async () => {
  paging.value.itemsPerPage = props.itemsPerPage
  filters.status = props.statuses
  filters.ownerID = props.ownerID
})
</script>
